import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { Loader2, ShieldCheck } from "lucide-react";
import { toast } from "sonner";
import { API, formatApiError } from "../lib/api";
import { useAuth } from "../context/AuthContext";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";

export default function ChangePassword() {
  const { setUser } = useAuth();
  const navigate = useNavigate();
  const [current, setCurrent] = useState("");
  const [next, setNext] = useState("");
  const [confirm, setConfirm] = useState("");
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState("");

  const submit = async (e) => {
    e.preventDefault();
    setError("");
    if (next !== confirm) {
      setError("La confirmation ne correspond pas au nouveau mot de passe.");
      return;
    }
    setLoading(true);
    try {
      await API.post("/auth/change-password", { current_password: current, new_password: next });
      const me = await API.get("/auth/me");
      setUser(me.data);
      toast.success("Mot de passe modifie avec succes.");
      navigate("/", { replace: true });
    } catch (err) {
      setError(formatApiError(err));
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="min-h-screen bg-[#0B132B] flex flex-col" data-testid="change-password-page">
      <div className="tricolor" />
      <div className="flex flex-1 items-center justify-center p-6">
        <div className="w-full max-w-md rounded-2xl bg-white dark:bg-[#111827] shadow-2xl p-8">
          <div className="text-center mb-6">
            <ShieldCheck className="mx-auto h-12 w-12 text-[#009E60]" />
            <h1 className="mt-3 font-heading text-2xl font-bold">Changement de mot de passe</h1>
            <p className="mt-1 text-sm text-muted-foreground">
              Pour des raisons de securite, vous devez definir un nouveau mot de passe avant de continuer.
            </p>
          </div>
          <form onSubmit={submit} className="space-y-4" data-testid="change-password-form">
            {error && (
              <div className="rounded-lg border border-red-200 bg-red-50 dark:bg-red-900/20 px-4 py-3 text-sm text-red-700 dark:text-red-300" data-testid="change-password-error">{error}</div>
            )}
            <div className="space-y-1.5">
              <label className="text-xs font-semibold uppercase tracking-wide text-muted-foreground">Mot de passe actuel</label>
              <Input type="password" value={current} onChange={(e) => setCurrent(e.target.value)} required data-testid="change-current" />
            </div>
            <div className="space-y-1.5">
              <label className="text-xs font-semibold uppercase tracking-wide text-muted-foreground">Nouveau mot de passe</label>
              <Input type="password" value={next} onChange={(e) => setNext(e.target.value)} required data-testid="change-new" />
              <p className="text-[11px] text-muted-foreground">Minimum 10 caracteres, avec majuscule, minuscule, chiffre et caractere special.</p>
            </div>
            <div className="space-y-1.5">
              <label className="text-xs font-semibold uppercase tracking-wide text-muted-foreground">Confirmation</label>
              <Input type="password" value={confirm} onChange={(e) => setConfirm(e.target.value)} required data-testid="change-confirm" />
            </div>
            <Button type="submit" disabled={loading} className="w-full bg-[#009E60] hover:bg-[#00804e] text-white" data-testid="change-submit">
              {loading ? <Loader2 className="mr-2 h-4 w-4 animate-spin" /> : null}
              Valider le nouveau mot de passe
            </Button>
          </form>
        </div>
      </div>
    </div>
  );
}
